import type { ResourceGlobal } from "@@/shared/acquire/resources/resource-global";
import type { ResourceReservation } from "@@/shared/acquire/resources/resource-reservation";
import { resourceReservationIdZodSchema } from "@@/shared/acquire/resources/resource-reservation-id";
import { generateResourceShortName } from "@@/shared/acquire/resources/resource.short-name";
import { translation } from "@@/shared/translations/translation";
import { z } from "zod";
import {
    dateRangeFactory,
    dateRangeZodObject,
} from "../../date-time/date-range";
import { timeRangeZodSchema } from "../../date-time/time-range";
import { agendaResourceDataZodObject } from "./agenda-resource-data";

const agendaItem_DropInDataZodObject = z.object({
    _type: z.literal("AGENDA_ITEM__DROP_IN_DATA"),
    reservationId: resourceReservationIdZodSchema,
    reservationDateRange: dateRangeZodObject,
    reservationTime: z.union([timeRangeZodSchema, dateRangeZodObject]),
    reservedQuantity: z.number(),
    resource: agendaResourceDataZodObject,
});

type AgendaItem_DropInData = z.infer<typeof agendaItem_DropInDataZodObject>;

const agendaItem_DropInDataFactory = {
    from: (params: {
        reservation: ResourceReservation & { type: "DROP_IN" };
        resource: ResourceGlobal;
    }): AgendaItem_DropInData => {
        const { reservation, resource } = params;
        return {
            _type: "AGENDA_ITEM__DROP_IN_DATA",
            reservationId: reservation._id,
            reservationTime: reservation.timeRange,
            reservationDateRange: dateRangeFactory.fromTimeRange({
                timeRange: reservation.timeRange,
            }),
            reservedQuantity: reservation.quantity,
            resource: {
                resourceId: resource._id,
                resourceType: resource._type,
                parentResources: [], // TODO!
                shortName: generateResourceShortName(resource),
                checkInStatus: {
                    // -------------------------------------
                    // We don't allow check-in for drop-ins yet,
                    // so we can set this to false
                    enabled: false,
                    // hasProp(resource, "checkInEnabled")
                    //     ? !!resource.checkInEnabled
                    //     : false,
                    value: "NONE",
                    timestamp: null,
                    // -------------------------------------
                },
                iconName: "fa-calendar-check",
                title: translation({
                    sv: "Drop-in",
                    en: "Drop-in",
                }),
            },
        };
    },
};

export { agendaItem_DropInDataFactory, agendaItem_DropInDataZodObject };
export type { AgendaItem_DropInData };
